import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { ImprimirPdfComponent } from './imprimir-pdf.component';
import { ImprimirInformeCabeceraSharedModule } from '../../imprimir/partes/informe-cabecera/imprimir-informe-cabecera.module.share';

@NgModule({
    declarations: [
        ImprimirPdfComponent
    ],
    imports: [ 
        CommonModule,
        ImprimirInformeCabeceraSharedModule,
        ButtonModule 
    ],
    exports: [ 
        ImprimirPdfComponent
     ],
    providers: [],
})
export class ImprimirPdfSharedModule {}